<template>
    <div>
      <b-row class="py-2">
        <b-alert
          class="position-fixed fixed-top m-0 rounded-0 text-center"
          fade
          :show="dismissCountDown"
          :variant="errorMessage.color"
          @dismissed="dismissed"
          >{{ errorMessage.text }}</b-alert
        >
      </b-row>
  
      <b-container fluid>
        <b-row>
          <b-col>
            <!--  proposal heading -->
            <b-row>
              <b-col cols="4">
                <h4 class="lead d-print-none d-none d-sm-block">
                  Minhas Propostas
                </h4>
              </b-col>
              <b-col cols="8">
                <div
                  class="text-center position-fixed d-print-none"
                  style="right: 15px; bottom: 35px; z-index: 1"
                  v-b-tooltip.hover.left
                  title="Criar nova proposta"
                >
                  <router-link :to="'/newOrder'">
                    <i class="fas fa-plus"></i>
                  </router-link>
                </div>
                <div class="d-flex justify-content-end">
                  <GlobalSearch
                    :tabIndex="tabIndex"
                    @tabOnSearch="tabOnSearch"
                    class="d-print-none"
                  />
                </div>
              </b-col>
            </b-row>
  
            <ProposalsToolbarControls
              class="d-print-none"
              :tab="tabs[tabIndex].content"
              :tabReqName="tabs[tabIndex].reqName"
              :proposalsLengthOfDataBase="proposals.length"
              :proposalsLengthOfSearchInput="filteredList.length"
              :proposalsLengthOfPagination="list.length"
              :proposalsLengthOfSearchOfTag="listToshow.length"
              :configsOrderBy="configs.orderBy"
              :configsOrder="configs.order"
              :tabIndex="tabIndex"
              @changeOrder="configs.order = $event"
              @changeOrderBy="configs.orderBy = $event"
              @setIndexToGlobal="tabOnSearch"
              @updateIndex="updateIndex"
              @openModal="showModal = true"
            />
           <b-row class="my-2">
              <b-collapse id="collapse-1" class="mt-2 w-100">
                <b-card>
                  <p class="card-text">Search By</p>
                  <b-row>
                    <b-col cols="2">Bank Branch</b-col>
                    <b-col cols="10">
                      <span
                        v-for="(branch, index) in bankBranches"
                        :key="index"
                        :class="{ 'mx-2': branch.name }"
                      >
                        <b-badge
                          :class="{
                            'bg-primary': isInArray('branch', branch),
                            'bg-light': !isInArray('branch', branch),
                            'text-dark': !isInArray('branch', branch),
                          }"
                          v-if="branch.name"
                          @click="
                            !isInArray('branch', branch)
                              ? searchByBranch.push(branch)
                              : removeItem('branch', branch)
                          "
                          >{{ branch.name }}</b-badge
                        >
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="my-2">
                    <b-col cols="2">Modality</b-col>
                    <b-col cols="10">
                      <span
                        v-for="(modality, index3) in modalities"
                        :key="index3"
                        class="mx-2"
                      >
                        <b-badge
                          :class="{
                            'bg-info': isInArray('modality', modality),
                            'bg-light': !isInArray('modality', modality),
                            'text-dark': !isInArray('modality', modality),
                          }"
                          @click="
                            !isInArray('modality', modality)
                              ? searchByModality.push(modality)
                              : removeItem('modality', modality)
                          "
                          >{{ modality }}</b-badge
                        >
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="my-2">
                    <b-col cols="2">User</b-col>
                    <b-col cols="10">
                      <span
                        v-for="(user, index2) in users"
                        :key="index2"
                        class="mx-2"
                      >
                        <b-badge
                          :class="{
                            'bg-success': isInArray('user', user),
                            'bg-light': !isInArray('user', user),
                            'text-dark': !isInArray('user', user),
                          }"
                          @click="
                            !isInArray('user', user)
                              ? searchByUser.push(user)
                              : removeItem('user', user)
                          "
                          >{{ user.name }}</b-badge
                        >
                      </span>
                    </b-col>
                  </b-row>
                </b-card>
              </b-collapse>
            </b-row>
  
            <b-row v-if="list.length == 0 && preloader" align-h="center">
              <b-col>
                <div class="text-center">
                  <b-skeleton
                    class="mb-1"
                    animation="fade"
                    width="100%"
                    height="73px"
                  ></b-skeleton>
                  <b-skeleton
                    class="my-1"
                    animation="fade"
                    width="100%"
                    height="73px"
                  ></b-skeleton>
                  <b-skeleton
                    class="my-1"
                    animation="fade"
                    width="100%"
                    height="73px"
                  ></b-skeleton>
                  <b-skeleton
                    class="my-1"
                    animation="fade"
                    width="100%"
                    height="73px"
                  ></b-skeleton>
                  <b-skeleton
                    class="my-1"
                    animation="fade"
                    width="100%"
                    height="73px"
                  ></b-skeleton>
                </div>
              </b-col>
            </b-row>
            <b-row class="my-2" v-if="proposals.length > 0 && !preloader">
              <b-col>
                <!-- End the preloader while making a request -->
                <!-- Start of the pull the proper component if it is the active tab -->
                <template v-if="proposals.length > 0 && !preloader">
                  <!-- List the proposals on the card -->
                  <div fluid v-for="(item, index) of list" :key="index">
                    <ExpectedProposalsForUser
                      :data="item"
                      :tabSelected="tabs[tabIndex].title"
                    ></ExpectedProposalsForUser>
                  </div>
                  <div
                    class="infinite-wrapper"
                    v-if="listToRender.length > 0 && !preloader"
                  >
                    <infinite-loading @infinite="infiniteHandler">
                      <span slot="spinner" v-if="list.length == 0 && !preloader">
                        <b-skeleton
                          class="mb-1"
                          animation="fade"
                          width="100%"
                          height="73px"
                        ></b-skeleton>
                        <b-skeleton
                          class="my-1"
                          animation="fade"
                          width="100%"
                          height="73px"
                        ></b-skeleton>
                        <b-skeleton
                          class="my-1"
                          animation="fade"
                          width="100%"
                          height="73px"
                        ></b-skeleton>
                        <b-skeleton
                          class="my-1"
                          animation="fade"
                          width="100%"
                          height="73px"
                        ></b-skeleton>
                        <b-skeleton
                          class="my-1"
                          animation="fade"
                          width="100%"
                          height="73px"
                        ></b-skeleton>
                      </span>
                      <span v-else></span>
  
                      <span slot="no-more">
                        <p class="text-primary font-weight-bold my-4">
                          Todas propostas listadas ;)
                        </p>
                      </span>
                    </infinite-loading>
                  </div>
                </template>
                <!-- End of the pull the proper component if it is the active tab -->
                <!-- Start of message if no proposal is found in the referring tab -->
                <h3
                  class="text-center lead mt-5"
                  v-if="proposals == '' && !preloader"
                >
                  Nenhuma {{ tab.isBlank }} encontrada
                </h3>
                <!-- End of message if no proposal is found in the referring tab -->
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState, mapGetters } from "vuex";
  import ProposalsToolbarControls from "../components/ProposalsTypes/ProposalsToolbarControls.vue";
  import ExpectedProposalsForUser from "../components/ProposalsTypes/ExpectedProposalsForUser.vue";
  import Search from "../components/Search.vue";
  import GlobalSearch from "../components/GlobalSearch.vue";
  import InfiniteLoading from "vue-infinite-loading";
  
  export default {
    name: "Proposals",
    components: {
      ProposalsToolbarControls,
      ExpectedProposalsForUser,
      Search,
      GlobalSearch,
      InfiniteLoading,
    },
    data() {
      return {
        req: "expected",
        tabIndex: 0,
        configs: {
          orderBy: "",
          order: "",
        },
        amountTotal: 0,
        amountInformation: [
          {
            list: [],
            modality: "SBPE",
            amount: 0,
            averageTicket: 750000.0,
            totalProposals: 0,
          },
          {
            list: [],
            modality: "CCFGTS",
            amount: 0,
            averageTicket: 150000.0,
            totalProposals: 0,
          },
          {
            list: [],
            modality: "PMCMV",
            amount: 0,
            averageTicket: 125000.0,
            totalProposals: 0,
          },
          {
            list: [],
            modality: "PRÓ COTISTA",
            amount: 0,
            averageTicket: 0.0,
            totalProposals: 0,
          },
        ],
        showCollapseSuma: false,
        tabs: [
          {
            title: "Previstas",
            text: "Expected",
            reqName: "expected",
            content: "propostas previstas",
            isBlank: "proposta prevista",
          },
          {
            title: "Todas",
            text: "All",
            reqName: "actived",
            content: "propostas",
            isBlank: "proposta ativa",
          },
          {
            title: "Novas",
            text: "News",
            reqName: "steps.riskAssessment.actived",
            content: "propostas novas",
            isBlank: "nova proposta",
          },
          {
            title: "Aprovadas",
            text: "Approved",
            reqName: "isApproved",
            content: "propostas aprovadas",
            isBlank: "proposta aprovada",
          },
          {
            title: "Em andamento",
            text: "InProgress",
            reqName: "",
            content: "propostas em andamento",
            isBlank: "proposta em andamento",
          },
          {
            title: "CICOB",
            text: "CICOB",
            reqName: "",
            content: "propostas na CICOB",
            isBlank: "proposta na CICOB",
          },
          {
            title: "Contratadas",
            text: "Contracted",
            reqName: "",
            content: "propostas contratadas",
            isBlank: "proposta contrada",
          },
          {
            title: "Com pendência(s)",
            text: "Pendings",
            reqName: "",
            content: "propostas com pendência(s)",
            isBlank: "proposta com pendência(s)",
          },
          {
            title: "Reprovadas",
            text: "Disapproved",
            reqName: "",
            content: "propostas reprovadas",
            isBlank: "proposta reprovada",
          },
          {
            title: "Descontinuadas",
            text: "Discontinued",
            reqName: "",
            content: "propostas descontinuadas",
            isBlank: "proposta descontinuada",
          },
          {
            title: "",
            text: "",
            reqName: "",
            content: "",
            isBlank: "",
          },
          {
            title: "Em atendimento",
            text: "Em atendimento",
            reqName: "",
            content: "propostas Em atendimento",
            isBlank: "proposta Em atendimento",
            index: 11,
          },
        ],
        list: [],
        proposalList: [],
        currentScroll: 1,
        searchByBranch: [],
        searchByUser: [],
        searchByModality: [],
        listToshow: [],
        modalities: ["SBPE", "CCFGTS", "PMCMV"],
        sbpeList: [],
        sbpeSum: 0,
        ccfgtsList: [],
        ccfgtsSum: 0,
        pmcmvList: [],
        pmcmvSum: 0,
        delaySort: false,
        globalTabType: "",
        novasProposalLength: null,
        showPeriodDialog: false,
        periodAmount: 0,
        showModal: false,
        show: false,
        title: 1,
      };
    },
    watch: {
      async tabIndex(newVal, oldVal) {
        let collapse = document.getElementById("collapse-1");
        collapse.classList.remove("show");
        collapse.style.display = "none";
        this.list = [];
        this.listToshow = [];
        this.searchByBranch = [];
        this.searchByUser = [];
        this.searchByModality = [];
        if (newVal === 7) {
          this.$store.state.selectedPendingOption = "Risk Assessment";
        }
        if (oldVal === 2) {
          // this.novasProposalLength = JSON.parse(JSON.stringify(this.proposals))
          if (this.proposals.length) {
            console.log(
              oldVal,
              newVal,
              "44444444444444444",
              this.novasProposalLength,
              this.proposals.length
            );
          }
        }
        await this.getProposals({
          tabIndex: newVal,
          scroll: this.currentScroll,
          globalTabType: this.globalTabType,
        });
        this.configs = {
          orderBy: this.condfigOrderBy_proposal,
          order: this.configsOrder_proposal,
        };
        this.delaySort = true;
        setTimeout(() => {
          this.delaySort = false;
        }, 1000);
        // this.infiniteHandler();
      },
      async globalTabType(newVal) {
        await this.getProposals({
          tabIndex: 10,
          scroll: this.currentScroll,
          globalTabType: newVal,
        });
      },
      searchData(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.listToshow.length && newVal.length) {
            this.listToshow = this.listToshow.filter((proposal) => {
              return (
                proposal.cpf.toLowerCase().includes(newVal.toLowerCase()) ||
                proposal.bankBranch
                  .toLowerCase()
                  .includes(newVal.toLowerCase()) ||
                proposal.name.toLowerCase().includes(newVal.toLowerCase())
              );
            });
          } else {
            this.filterItem();
          }
          this.list = [];
          this.infiniteHandler();
        }
      },
      searchByUser(newValue) {
        if (newValue) {
          this.filterItem();
        }
      },
      searchByBranch(newVal, oldVal) {
        if (newVal) {
          this.filterItem();
        }
      },
      searchByModality(newVal, oldVal) {
        if (newVal) {
          this.filterItem();
        }
      },
      "configs.orderBy"(newVal) {
        if (newVal) {
          this.list = [];
          if (this.delaySort === false) {
            this.infiniteHandler();
          }
        }
      },
      "configs.order"(newVal) {
        if (newVal) {
          this.list = [];
          if (this.delaySort === false) {
            this.infiniteHandler();
          }
        }
      },
      filteredList(newVal) {
        if (newVal) {
          this.list = [];
          // this.infiniteHandler();
        }
      },
      proposals(newVal) {
        console.log("hhhhhhhhhhhhhhh", newVal, this.tabIndex);
      },
    },
    computed: {
      ...mapState([
        "user",
        "proposals",
        "preloader",
        "error",
        "errorMessage",
        "dismissCountDown",
        "searchData",
        "users",
        "bankBranches",
        "currentYearProposals",
        "condfigOrderBy_proposal",
        "configsOrder_proposal",
        "statePeriodAmount",
        "changeToast",
      ]),
  
      ...mapGetters(["proposalFilterOfSearch", "filteredList"]),
      activeLink() {
        return this.tabs[this.tabIndex].text;
      },
      listToRender() {
        let array = [];
        if (
          this.searchByUser.length ||
          this.searchByBranch.length ||
          this.searchByModality.length
        ) {
          array = _.orderBy(
            this.listToshow,
            this.configs.orderBy,
            this.configs.order
          );
        } else {
          array = _.orderBy(
            this.filteredList,
            this.configs.orderBy,
            this.configs.order
          );
          this.listToshow = [];
        }
        return array;
      },
      soma() {
        let sum = 0;
  
        if (this.listToshow == "") {
          for (let i = 0; i < this.proposals.length; i++) {
            sum += this.proposals[i].approvedFinancingAmount;
          }
          return sum;
        } else {
          for (let i = 0; i < this.listToshow.length; i++) {
            sum += this.listToshow[i].approvedFinancingAmount;
          }
          return sum;
        }
      },
      setAmountInformation() {
        this.amountInformation[0].list = [];
        this.amountInformation[1].list = [];
        this.amountInformation[2].list = [];
        this.amountInformation[3].list = [];
  
        if (this.listToshow == "") {
          for (let i = 0; i < this.proposals.length; i++) {
            if (this.proposals[i].operationModality == "SBPE") {
              this.sbpeList.push(this.proposals[i].approvedFinancingAmount);
              this.amountInformation[0].list.push(
                this.proposals[i].approvedFinancingAmount
              );
            } else if (this.proposals[i].operationModality == "CCFGTS") {
              this.pmcmvList.push(this.proposals[i].approvedFinancingAmount);
              this.amountInformation[1].list.push(
                this.proposals[i].approvedFinancingAmount
              );
            } else if (this.proposals[i].operationModality == "PMCMV") {
              this.pmcmvList.push(this.proposals[i].approvedFinancingAmount);
              this.amountInformation[2].list.push(
                this.proposals[i].approvedFinancingAmount
              );
            } else {
              this.pmcmvList.push(this.proposals[i].approvedFinancingAmount);
              this.amountInformation[3].list.push(
                this.proposals[i].approvedFinancingAmount
              );
            }
          }
        } else {
          for (let i = 0; i < this.listToshow.length; i++) {
            if (this.listToshow[i].operationModality == "SBPE") {
              this.sbpeList.push(this.listToshow[i].approvedFinancingAmount);
              this.amountInformation[0].list.push(
                this.listToshow[i].approvedFinancingAmount
              );
            } else if (this.listToshow[i].operationModality == "CCFGTS") {
              this.pmcmvList.push(this.listToshow[i].approvedFinancingAmount);
              this.amountInformation[1].list.push(
                this.listToshow[i].approvedFinancingAmount
              );
            } else if (this.listToshow[i].operationModality == "PMCMV") {
              this.pmcmvList.push(this.listToshow[i].approvedFinancingAmount);
              this.amountInformation[2].list.push(
                this.listToshow[i].approvedFinancingAmount
              );
            } else {
              this.pmcmvList.push(this.listToshow[i].approvedFinancingAmount);
              this.amountInformation[3].list.push(
                this.listToshow[i].approvedFinancingAmount
              );
            }
          }
        }
      },
      sbpeValuesSum() {
        let sum = 0;
  
        for (let i = 0; i < this.amountInformation[0].list.length; i++) {
          sum += this.amountInformation[0].list[i];
        }
        this.amountInformation[0].amount = sum;
  
        /* for (let i = 0; i < this.sbpeList.length; i++) {
            sum += this.sbpeList[i];
          } */
        return sum;
      },
      ccfgtsValuesSum() {
        let sum = 0;
  
        for (let i = 0; i < this.amountInformation[1].list.length; i++) {
          sum += this.amountInformation[1].list[i];
        }
        this.amountInformation[1].amount = sum;
  
        /* for (let i = 0; i < this.sbpeList.length; i++) {
            sum += this.sbpeList[i];
          } */
        return sum;
      },
      pmcmvValuesSum() {
        let sum = 0;
  
        for (let i = 0; i < this.amountInformation[2].list.length; i++) {
          sum += this.amountInformation[2].list[i];
        }
        this.amountInformation[2].amount = sum;
  
        /* for (let i = 0; i < this.sbpeList.length; i++) {
            sum += this.sbpeList[i];
          } */
        return sum;
      },
      proCotistaValuesSum() {
        let sum = 0;
  
        for (let i = 0; i < this.amountInformation[3].list.length; i++) {
          sum += this.amountInformation[3].list[i];
        }
        this.amountInformation[3].amount = sum;
  
        /* for (let i = 0; i < this.sbpeList.length; i++) {
            sum += this.sbpeList[i];
          } */
        return sum;
      },
      getRealizedAmount() {
        const addProperties = this.currentYearProposals.reduce((acc, n) => {
          if (acc.hasOwnProperty("operationValue"))
            acc["operationValue"] += n["operationValue"];
          else acc["operationValue"] = n["operationValue"];
          return acc;
        }, {});
        return addProperties.operationValue;
      },
      gapAmount() {
        return this.getRealizedAmount - this.periodAmount;
      },
      // TabComponent: function() {
      //   return "Tab" + this.tabs[this.tabIndex].text.replace(/ /g, "");
      //   //return 'Tab' + this.tabs[this.tabIndex].text.replace(/ /g, '')
      // }
    },
    methods: {
      ...mapActions([
        "getProposals",
        "dismissed",
        "getModifiedProposals",
        "getBankBranches",
        "getUsers",
        "getNewProposals",
        "updatePeriodAmount",
        "fetchPeriodAmount",
        "getCurrentYearProposals",
        "listenersDataBase",
      ]),
      gettabIndexIndex(e) {
        this.tabIndex = e;
      },
  
      definesLowerValueOfTheOperation(data) {
        if (data.approvedFinancingAmount === 0) {
          return data.intendedFinancingValue;
        } else if (
          data.intendedFinancingValue <= data.approvedFinancingAmount &&
          data.operationValue === 0
        ) {
          return data.intendedFinancingValue;
        } else if (
          data.approvedFinancingAmount <= data.intendedFinancingValue &&
          data.operationValue === 0
        ) {
          return data.approvedFinancingAmount;
        } else {
          return data.operationValue;
        }
      },
  
      // setReq() {
      //   console.log(this.TabComponent);
      // },
      // Requests EXPECTED proposals from the database
      isExpected(status, situation) {
        console.log("isExpected called");
        if (item.expected) {
          return true;
        } else {
          return false;
        }
      },
      // Requests ALLS proposals from the database
      // This calls all active proposals.
      // There is no logic to it
      isAll(status, situation) {
        console.log("isExpected called");
        if (item.expected) {
          return true;
        } else {
          return false;
        }
      },
  
      // Requests NEWS proposals from the database
      isNews(situation, status) {
        console.log("isNews called");
        if (!item.steps.riskAssessment) {
          return true;
        } else {
          return false;
        }
      },
      // Requests APPROVED proposals from the database
      isApproved(status, situation) {
        console.log("isApproved called");
        if (
          item.expected
          // item.actived &&
          // item.expected &&
          // item.steps.contract.status.trim() != "Evoluída"
        ) {
          return true;
        } else {
          return false;
        }
      },
      // Requests PROGRESS proposals from the database
      isProgress(status, situation) {
        console.log("isProgress called");
        if (item.steps.engineering.actived && !item.steps.contract.actived) {
          return true;
        } else {
          return false;
        }
      },
      // Requests CICOB proposals from the database
      isCicob(status, situation) {
        console.log("isCicob called");
        if (
          item.steps.contract.situation.trim() == "Em análise de conformidade"
        ) {
          return true;
        } else {
          return false;
        }
      },
      // Requests CONTRACTED proposals from the database
      isContracted(status, situation) {
        console.log("isContracted called");
        if (item.steps.contract.situation == "Emitida") {
          return true;
        } else {
          return false;
        }
      },
      // Requests PENDING proposals from the database
      isPending(status, situation) {
        console.log("isPending called");
        if (
          (status == "Com pendência(s)" && status != "") ||
          status == "Com restrição" ||
          status == "Com restrição e com pendência" ||
          status == "Pept"
        ) {
          return true;
        } else {
          return false;
        }
      },
      // Requests REJECTED proposals from the database
      isRejected(status, situation) {
        console.log("isRejected called");
        if ((status == "Reprovado" && status != "") || status == "Inválido") {
          return true;
        } else {
          return false;
        }
      },
      // Requests DISCONTINUED proposals from the database
      isDiscontinued(status, situation) {
        console.log("isDiscontinued called");
        if (!item.actived) {
          return true;
        } else {
          return false;
        }
      },
  
      async infiniteHandler($state) {
        if (this.list.length === this.listToRender.length) {
          $state.complete();
          this.$bvToast.toast(`Todas suas propostas foram listadas. :)`, {
            title: "Eiiii!",
            variant: "primary",
            autoHideDelay: 3000,
          });
        } else {
          await setTimeout(async () => {
            let temp = [];
            for (
              let i = this.list.length == 0 ? 0 : this.list.length;
              i <= this.list.length + 10;
              i++
            ) {
              if (i < this.listToRender.length) {
                temp.push(this.listToRender[i]);
              }
            }
            this.list = this.list.concat(temp);
            $state.loaded();
          }, 1000);
        }

        this.$forceUpdate();
      },
  
      // check selected badge is in array or not
      isInArray(str, obj) {
        let res = null;
        if (str === "branch") {
          res = this.searchByBranch.some(function(el) {
            return el.id === obj.id;
          });
        } else if (str === "modality") {
          res = this.searchByModality.some(function(el) {
            return el === obj;
          });
        } else {
          res = this.searchByUser.some(function(el) {
            return el.id === obj.id;
          });
        }
        return res;
      },
  
      removeItem(str, obj) {
        if (str === "branch") {
          let index = this.searchByBranch.findIndex((x) => x.id === obj.id);
          this.searchByBranch.splice(index, 1);
          this.$forceUpdate();
        } else if (str === "modality") {
          let index3 = this.searchByModality.findIndex((x) => x === obj);
          this.searchByModality.splice(index3, 1);
          this.$forceUpdate();
        } else {
          let index2 = this.searchByUser.findIndex((x) => x.id === obj.id);
          this.searchByUser.splice(index2, 1);
          this.$forceUpdate();
        }
      },
      filterItem() {
        let finallist = [];
        if (this.searchByBranch.length && !this.searchByUser.length) {
          finallist = this.filteredList.filter((o1) =>
            this.searchByBranch.some((o2) => o1.bankBranch === o2.name)
          );
          if (this.searchByModality.length) {
            this.listToshow = finallist.filter((o1) =>
              this.searchByModality.some((o2) => o1.operationModality === o2)
            );
          } else {
            this.listToshow = finallist;
          }
        } else if (this.searchByUser.length && !this.searchByBranch.length) {
          finallist = this.filteredList.filter((o1) =>
            this.searchByUser.some((o2) => o1.created_by === o2.email)
          );
          if (this.searchByModality.length) {
            this.listToshow = finallist.filter((o1) =>
              this.searchByModality.some((o2) => o1.operationModality === o2)
            );
          } else {
            this.listToshow = finallist;
          }
        } else if (this.searchByUser.length && this.searchByBranch.length) {
          let userArr = this.filteredList.filter((o1) =>
            this.searchByUser.some((o2) => o1.created_by === o2.email)
          );
          let branchArr = this.filteredList.filter((o1) =>
            this.searchByBranch.some((o2) => o1.bankBranch === o2.name)
          );
          finallist = userArr.filter((ol) =>
            branchArr.some((o2) => ol.id === o2.id)
          );
          if (this.searchByModality.length) {
            this.listToshow = finallist.filter((o1) =>
              this.searchByModality.some((o2) => o1.operationModality === o2)
            );
          } else {
            this.listToshow = finallist;
          }
        } else if (
          this.searchByModality.length &&
          !this.searchByUser.length &&
          !this.searchByBranch.length
        ) {
          this.listToshow = this.filteredList.filter((o1) =>
            this.searchByModality.some((o2) => o1.operationModality === o2)
          );
        }
        this.list = [];
        this.infiniteHandler();
      },
      tabOnSearch(val) {
        this.tabIndex = val.index;
        this.globalTabType = val.type;
      },
      updateIndex(val) {
        this.tabIndex = val;
      },
      handleSetPeriodAmount() {
        this.updatePeriodAmount(this.periodAmount);
        this.showPeriodDialog = false;
      },
      closeNotification() {
        this.setChangeToast({ value: false, title: "", message: "" });
      },
      showNotification() {
        this.show = true;
  
        this.title = this.title + 1;
      },
    },
    async created() {
      this.listenersDataBase();
      this.getBankBranches();
      this.getUsers();
      this.configs = {
        orderBy: this.condfigOrderBy_proposal,
        order: this.configsOrder_proposal,
      };
      this.getCurrentYearProposals();
      await this.fetchPeriodAmount();
      this.periodAmount = this.statePeriodAmount;
    },
    async beforeMount() {
      this.getNewProposals();
      this.getProposals({ tabIndex: this.tabIndex, scroll: this.currentScroll });
    },
  };
  </script>
  
  <style scoped>
  i.fas.fa-plus {
    color: #ffffff;
    background-color: #007bff;
    height: 50px;
    width: 50px;
    line-height: 50px;
    border-radius: 35px;
  }
  
  i.fas.fa-plus:hover {
    color: #ffffff;
    background-color: #ec9a3c;
    border-radius: 35px;
  }
  
  .list-group-wrapper {
    position: relative;
  }
  
  .list-group {
    overflow: auto;
    height: 50vh;
    border: 2px solid #dce4ec;
    border-radius: 5px;
  }
  .list-group-item {
    margin-top: 1px;
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: 2px solid #dce4ec;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .exp {
    position: relative;
    bottom: 7px;
  }
  </style>
  